export function getPhotoViewerHref(projectName?: string | null) {
  if (!projectName) return undefined

  const url = new URL('https://cimsapps.horrocks.com/photoviewer/')
  url.searchParams.set('project', projectName)
  return url.toString()
}
